import { useContext } from "react";

import Template from "../../components/template";
import FtmIdentification from "./components/FtmIdentification";
import PersonalDetails from "./components/PersonalDetails";
import { Context } from "./Provider";
import PersonalDocumentsApproved from "./components/PersonalDocumentsApproved";
import NotificationMessages from "./components/NotificationMessages";
import FtmSkills from "./components/FtmSkills";
import EnableGPSTracker from "./components/EnableGPSTracker";
import NavCardAndHistory from "./components/NavCardAndHistory";
import History from "./components/history/History";
import gpsTrackerSteps from "./components/gpsTrackerSteps";
import FtmMap from "./components/ftmMap/FtmMap";

const Html = () => {
    const { identificationDetails, showFtmMap } = useContext(Context);
    
    const lastStep = identificationDetails?.last_approval_process_step?.ftm_approval_process_step;
    const lastStepKey = lastStep?.ftm_approval_process_step_key;

    return (
        <Template>
            <div className="container-fluid my-3 py-3">
                <div className="row mb-5">
                    <NavCardAndHistory />
                    <div className="col-lg-6 mt-lg-0 mt-4">
                        <FtmIdentification />
                        <NotificationMessages color="warning" />

                        {!lastStepKey && <PersonalDetails />}

                        {lastStepKey === "ALL_PERSONAL_DETAILS_APPROVED" && <PersonalDocumentsApproved />}
                        {lastStepKey === "ALL_PERSONAL_DOCUMENTS_APPROVED" && <FtmSkills />}

                        {gpsTrackerSteps.includes(lastStepKey) && <EnableGPSTracker />}
                    </div>

                    <div className="col-lg-3 mt-lg-0 mt-4">
                        <History />
                        {showFtmMap && <FtmMap/>}
                    </div>
                </div>
            </div>
        </Template>
    );
};

export default Html;